<div class="col-md-6 d-inline-flex mb-4">
    <div class="field-input w-100">
        <label class="form-labels">{{field.label}}<span *ngIf="field.required" class="text-danger">*</span></label>
        <mat-form-field class="field-input-text mr-md-2 common-init" [formGroup]="group">
            <input matInput [formControlName]="field.name" [placeholder]="field.placeholder" />
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
            </ng-container>
        </mat-form-field>
    </div>
</div>
